import { render } from "./footerPart.vue?vue&type=template&id=586bce8a&scoped=true"
import script from "./footerPart.vue?vue&type=script&lang=js"
export * from "./footerPart.vue?vue&type=script&lang=js"

import "./footerPart.vue?vue&type=style&index=0&id=586bce8a&scoped=true&lang=less"

import exportComponent from "/root/drive/src/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586bce8a"]])

export default __exports__